import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

//import { Observable } from 'rxjs';

@Injectable()
export class GroupInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // Clone the request and replace the original headers with
        // cloned headers, updated with the groups.
        let grp = sessionStorage.getItem('grp');

        if (grp != null) {
            const grpReq = req.clone({
                headers: req.headers.set('grp', grp),
            });

            // send cloned request with header to the next handler.
            return next.handle(grpReq);
        }

        return next.handle(req);
    }
}
